(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["le-avis-clients"] && !Shopify.designMode) return;
  try {
    
(function () {
  function updateArrows(list) {
    var viewport = list.closest('.le-avis__viewport');
    if (!viewport) return;
    var prev = viewport.querySelector('.le-avis__arrow--prev');
    var next = viewport.querySelector('.le-avis__arrow--next');
    if (!prev || !next) return;
    var max = list.scrollWidth - list.clientWidth;
    var scrollable = max > 2;
    prev.hidden = !scrollable;
    next.hidden = !scrollable;
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft >= max - 2;
  }

  function updateAll() {
    document.querySelectorAll('.le-avis__list').forEach(updateArrows);
  }

  document.addEventListener('scroll', function (event) {
    var t = event.target;
    if (t && t.classList && t.classList.contains('le-avis__list')) updateArrows(t);
  }, true);

  window.addEventListener('resize', updateAll);
  window.addEventListener('load', updateAll);
  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('shopify:section:load', updateAll);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // Flèches du carrousel
    var arrow = target.closest('.le-avis__arrow');
    if (arrow) {
      var viewport = arrow.closest('.le-avis__viewport');
      var list = viewport && viewport.querySelector('.le-avis__list');
      var card = list && list.querySelector('.le-avis__card');
      if (list && card) {
        var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        var dir = arrow.classList.contains('le-avis__arrow--prev') ? -1 : 1;
        list.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
      }
      return;
    }

    // Fermeture par la croix
    var closeBtn = target.closest('.le-avis__modal-close');
    if (closeBtn) {
      var openDialog = closeBtn.closest('dialog');
      if (openDialog) openDialog.close();
      return;
    }

    // Fermeture par le fond (le clic tombe sur l'element dialog lui-meme)
    if (target.tagName === 'DIALOG' && target.classList.contains('le-avis__modal')) {
      target.close();
      return;
    }

    // Ouverture depuis une carte raccourcie
    var trigger = target.closest('.le-avis__trigger');
    if (!trigger) return;

    var section = trigger.closest('.le-avis');
    var card2 = trigger.closest('.le-avis__card');
    if (!section || !card2) return;

    var dialog = section.querySelector('.le-avis__modal');
    if (!dialog) return;

    var stars = dialog.querySelector('.le-avis__modal-stars');
    var cardStars = card2.querySelector('.le-avis__stars');
    if (stars) stars.innerHTML = cardStars ? cardStars.innerHTML : '';

    var body = dialog.querySelector('.le-avis__modal-body');
    if (body) body.textContent = card2.getAttribute('data-le-avis-body') || '';

    var name = dialog.querySelector('.le-avis__modal-name');
    if (name) name.textContent = card2.getAttribute('data-le-avis-name') || '';

    var verifiedText = card2.getAttribute('data-le-avis-verified') || '';
    var verified = dialog.querySelector('.le-avis__modal-verified');
    if (verified) {
      verified.textContent = verifiedText;
      verified.hidden = verifiedText === '';
    }

    var productText = card2.getAttribute('data-le-avis-product') || '';
    var product = dialog.querySelector('.le-avis__modal-product');
    if (product) {
      product.textContent = productText;
      product.hidden = productText === '';
    }

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
